import { text_mod_29, } from "../text/Text.js";
export const module29 = {
  title:
    "Літера Й велика",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_29,
    },
  ]
};